import { useEffect, useRef, useState } from 'react';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import {
    faBenchTree as fasBenchTree,
    faHome as fasHome,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../../../../../../helpers/class/Checkers';
import Methods from '../../../../../../helpers/class/Methods';
import SpacesMenu from '../../../partials/spaces/SpacesMenu';
import SpacesTabContent from '../../../partials/spaces/SpacesTabContent';
import { useDispatch, useSelector } from "react-redux";
import { fetchPropertySpaces } from "../../../../../../redux/actions";
import ExtendedSpaces from "./ExtendedSpaces";
import CompactSpaces from "./CompactSpaces";
import { fetchBuilderSettingByKey } from "../../../../../../helpers/MethodHelper";
import ExtendedCarouselSpaces from "./ExtendedCarouselSpaces";
import BedroomsView from './BedroomsView';

export default function Spaces(props) {

    const areasLayoutSetting = useSelector(state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_propertyview_layout'));

    return (
        (
            (props.areaSqm != null || props.areaOutdoorSqm != null) ||
            (props.spaces.hasOwnProperty('tab_content') && props.spaces.tab_content.length > 0)
        ) &&
        <div id="pro_detail_spaces" className="pb-5">
            <div className="row w-100 no-margin">
                {
                    areasLayoutSetting=='carousel' ?
                        <>
                            <ExtendedCarouselSpaces />
                        </>
                        :
                        <>
                            {
                                areasLayoutSetting=='thumbnails' ?
                                    <>
                                        <ExtendedSpaces isHotel={props.isHotel} />
                                    </>
                                    :
                                    <>
                                        <CompactSpaces areaSqm={props.areaSqm} areaOutdoorSqm={props.areaOutdoorSqm} spaces={props.spaces} />
                                    </>
                            }
                        </>
                }
            </div>
        </div>
    )
}